export const AllowedFileTypes = ["image/png", "image/jpeg", "application/pdf", ".png", ".jpg", ".jpeg"];
export const MaxFileSize = 3; // 3MB